import Blue from '~/core';

new Blue({
  name: 'OrderSummary',
  selector: '.checkout__order-summary-control',
  setup(control) {
    const originalOverflow = document.body.style.overflow;
    const container = control.parentElement;
    const header = document.querySelector('.header');
    const overlay = document.querySelector('.checkout__order-summary-overlay');

    const updateDrawerOffset = () => {
      if (!container || !header) return;
      const rect = header.getBoundingClientRect();
      const offset = Math.max(0, rect.bottom);
      container.style.setProperty('--checkout-order-summary-offset-top', `${offset}px`);
    };

    this.$addEvents(control, 'click.stop.prevent', () => {
      updateDrawerOffset();
      container.classList.toggle('open');

      if (container.classList.contains('open')) {
        document.body.style.overflow = 'hidden';
        control.querySelector('.checkout__order-summary-open').setAttribute('aria-hidden', 'true');
        control.querySelector('.checkout__order-summary-close').removeAttribute('aria-hidden');
      } else {
        document.body.style.overflow = originalOverflow;
        control.querySelector('.checkout__order-summary-open').removeAttribute('aria-hidden');
        control.querySelector('.checkout__order-summary-close').setAttribute('aria-hidden', 'true');
      }
    })

    this.$addEvents(overlay, 'click.stop.prevent', () => {
      container.classList.remove('open');
      document.body.style.overflow = originalOverflow;
    })

    new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        container.classList.toggle('fixed', !entry.isIntersecting);
        updateDrawerOffset();
      });
    }).observe(header);

    this.$addEvents(window, 'resize', updateDrawerOffset);
    this.$addEvents(window, 'scroll', updateDrawerOffset);
    updateDrawerOffset();
  },
});
